import { useSyncExternalStore } from 'react';
import { getConsentState, subscribeConsent } from './consentManager';

/**
 * React binding for the consent manager. Re-renders subscribers whenever the
 * consent state changes (banner accept/decline, note dismissal, preferences
 * reopen). Backed by `useSyncExternalStore` so it stays consistent with the
 * module-level state that governs the pixel.
 */
export function useConsent() {
  return useSyncExternalStore(subscribeConsent, getConsentState, getConsentState);
}
